class Observer {
	constructor(element, observable) {
		this.DOM = {element, observable};

		this.initObserver();
	}
	initObserver = () => {
		const handler = (entries) => {
			this.toggle(entries[0].isIntersecting ? 'intersection' : 'clear');
		};

		if ('IntersectionObserver' in window) {
			const observer = new window.IntersectionObserver(handler, {rootMargin: '0px 0px 100px 0px'});
			observer.observe(this.DOM.observable);
		}
	};
	toggle = (action) => {
		this.DOM.element.classList[action === 'clear' ? 'add' : 'remove']('main-header--invert');
	};
}

const header = document.querySelector('.main-header');
const observable = document.querySelector('.main-header-observable');

if (header && observable) {
	new Observer(header, observable);
}
